/*
  Fichier : assets/product-catalog.js - v7
  - Clic sur une taille = ajout direct au panier.
  - Mobile : un tap sur la photo ouvre directement la fiche produit ; les tailles via le bouton « Tailles ».
  - Desktop : les tailles apparaissent au survol (CSS).
  - v7 : PCStockPool -> produits « épinglés » (data-pc-pinned) toujours affichés, côte à côte,
         à une position aléatoire (alignée sur la ligne) ; PCRandomGrid -> mélange aléatoire
         À L'INTÉRIEUR de chaque groupe (data-pc-group), les groupes gardent leur ordre,
         les épuisés (groupe 9) passent en dernier.
  - Garde anti-double-chargement, ré-init dans l'éditeur de thème.
*/

(function () {
  if (window.__pcCatalogLoaded) return;
  window.__pcCatalogLoaded = true;

  var CART_ADD_URL = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
    ? window.Shopify.routes.root + 'cart/add.js'
    : '/cart/add.js';

  document.addEventListener('click', function (event) {
    var sizeBtn = event.target.closest('.product-catalog-card__size-btn');
    if (sizeBtn) {
      event.preventDefault();
      event.stopPropagation();
      handleSizeAddToCart(sizeBtn);
      return;
    }

    var toggle = event.target.closest('.product-catalog-card__sizes-toggle');
    if (toggle) {
      event.preventDefault();
      event.stopPropagation();
      var card = toggle.closest('.product-catalog-card');
      if (!card) return;
      var willOpen = !card.classList.contains('sizes-revealed');
      closeAllRevealedCards(card);
      card.classList.toggle('sizes-revealed', willOpen);
      return;
    }

    if (!event.target.closest('.product-catalog-card')) {
      closeAllRevealedCards();
    }
  });

  function closeAllRevealedCards(except) {
    document.querySelectorAll('.product-catalog-card.sizes-revealed').forEach(function (el) {
      if (el !== except) el.classList.remove('sizes-revealed');
    });
  }

  function handleSizeAddToCart(btn) {
    if (btn.disabled) return;

    var card = btn.closest('.product-catalog-card');
    if (!card) return;

    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    var originalText = btn.textContent;
    btn.disabled = true;
    btn.classList.add('is-loading');

    fetch(CART_ADD_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, data: data };
        });
      })
      .then(function (result) {
        btn.classList.remove('is-loading');
        if (result.ok) {
          btn.classList.add('is-added');
          btn.textContent = '✓';
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: result.data }));
          updateCartCount();
        } else {
          btn.textContent = '!';
        }
      })
      .catch(function () {
        btn.classList.remove('is-loading');
        btn.textContent = '!';
      })
      .finally(function () {
        setTimeout(function () {
          btn.disabled = false;
          btn.classList.remove('is-added');
          btn.textContent = originalText;
        }, 1200);
      });
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function () {});
  }

  /* ------------------------------------------------------------------
     Utilitaires partagés
  ------------------------------------------------------------------ */
  var HIDDEN_CLASS = 'is-pc-hidden';

  function shuffle(list) {
    for (var i = list.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = list[i];
      list[i] = list[j];
      list[j] = tmp;
    }
    return list;
  }

  function cardsOf(grid) {
    return Array.prototype.slice.call(grid.querySelectorAll(':scope > .product-catalog-card'));
  }

  /* PCStockPool : bloc "Catalogue produits" en mode "stock"
     - les cartes data-pc-pinned sont TOUJOURS affichées, gardées côte à côte,
       insérées à un index pair (= même ligne sur 2 et 4 colonnes) tiré au hasard.
     - les autres sont mélangées et on en garde (nombre à afficher - épinglées). */
  var PCStockPool = {
    init: function (root) {
      if (!root || root.__pcInit) return;
      root.__pcInit = true;
      var grid = root.querySelector('[data-pc-stock-grid]');
      if (!grid) return;
      var show = parseInt(grid.getAttribute('data-pc-show'), 10) || 8;

      var all = cardsOf(grid);
      var pinned = all.filter(function (c) { return c.hasAttribute('data-pc-pinned'); });
      var others = shuffle(all.filter(function (c) { return !c.hasAttribute('data-pc-pinned'); }));

      var showOthers = Math.max(0, show - pinned.length);
      var visible = others.slice(0, showOthers);
      var hidden = others.slice(showOthers);

      if (pinned.length) {
        var slots = Math.floor(visible.length / 2) + 1;
        var at = 2 * Math.floor(Math.random() * slots);
        if (at > visible.length) at = visible.length;
        visible = visible.slice(0, at).concat(pinned, visible.slice(at));
      }

      visible.forEach(function (card) {
        grid.appendChild(card);
        card.classList.remove(HIDDEN_CLASS);
      });
      hidden.forEach(function (card) {
        grid.appendChild(card);
        card.classList.add(HIDDEN_CLASS);
      });
    },
    initAll: function (scope) {
      (scope || document).querySelectorAll('[data-pc-stock-pool]').forEach(PCStockPool.init);
    },
  };

  /* PCRandomGrid : bloc "Produits aléatoires"
     - data-pc-group="1..9" : mélange aléatoire dans chaque groupe, groupes dans l'ordre
       (1 = premium, 2 = accessoires, 3 = tracksuits, 4 = autres, 5 = non classés, 9 = épuisés). */
  var PCRandomGrid = {
    init: function (root) {
      if (!root || root.__pcInit) return;
      root.__pcInit = true;

      var grid = root.querySelector('[data-pc-random-grid]');
      if (!grid) return;

      var batch = parseInt(grid.getAttribute('data-pc-batch'), 10) || 10;
      var autoLoad = grid.getAttribute('data-pc-auto-load') === 'true';
      var moreBtn = root.querySelector('[data-pc-random-more]');
      var counter = root.querySelector('[data-pc-random-count]');
      var footer = root.querySelector('[data-pc-random-footer]');

      var groups = {};
      cardsOf(grid).forEach(function (card) {
        var g = parseInt(card.getAttribute('data-pc-group'), 10);
        if (isNaN(g)) g = 5;
        if (!groups[g]) groups[g] = [];
        groups[g].push(card);
      });

      var cards = [];
      Object.keys(groups)
        .map(Number)
        .sort(function (a, b) { return a - b; })
        .forEach(function (g) {
          cards = cards.concat(shuffle(groups[g]));
        });

      cards.forEach(function (card) {
        card.classList.add(HIDDEN_CLASS);
        grid.appendChild(card);
      });

      var shown = 0;

      function updateUI() {
        if (counter) counter.textContent = shown + ' / ' + cards.length;
        var done = shown >= cards.length;
        if (moreBtn) moreBtn.classList.toggle(HIDDEN_CLASS, done);
        if (footer) footer.classList.toggle('is-complete', done);
      }

      function reveal() {
        var end = Math.min(shown + batch, cards.length);
        for (var i = shown; i < end; i++) {
          cards[i].classList.remove(HIDDEN_CLASS);
        }
        shown = end;
        updateUI();
      }

      reveal();

      if (moreBtn) {
        moreBtn.addEventListener('click', function (event) {
          event.preventDefault();
          reveal();
        });
      }

      if (autoLoad && moreBtn && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && shown < cards.length) reveal();
            if (shown >= cards.length) io.disconnect();
          });
        }, { rootMargin: '300px 0px' });
        io.observe(moreBtn);
      }
    },
    initAll: function (scope) {
      (scope || document).querySelectorAll('[data-pc-random]').forEach(PCRandomGrid.init);
    },
  };

  window.PCStockPool = PCStockPool;
  window.PCRandomGrid = PCRandomGrid;

  function initAll(scope) {
    PCStockPool.initAll(scope);
    PCRandomGrid.initAll(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target || document);
  });
  document.addEventListener('shopify:block:select', function (event) {
    initAll(event.target || document);
  });
})();
